export const levels = {
  config: {
    type: 'config',
    childType: 'anomaly',
    columns: [
      { key: 'configName', label: 'Config Name' },
      { key: 'assignedSite', label: 'Assigned Site' },
      { key: 'designedFor', label: 'Designed For' }
    ],
    addFields: ['configName', 'assignedSite', 'designedFor']
  },
  anomaly: {
    type: 'anomaly',
    childType: 'severity',
    columns: [
      { key: 'anomalyName', label: 'Anomaly Name' },
      { key: 'anomalyColor', label: 'Anomaly Color' }
    ],
    addFields: ['anomalyName', 'anomalyColor']
  },
  severity: {
    type: 'severity',
    columns: [
      { key: 'severityLevel', label: 'Severity' },
      { key: 'comment', label: 'Comment' },
      { key: 'note', label: 'Note' },
      { key: 'action', label: 'Action' },
      { key: 'acceptanceLevel', label: 'Acceptance Level' }
    ],
    addFields: ['severityLevel', 'comment', 'note', 'action', 'acceptanceLevel']
  }
}
